export default {
    banOperate: true,
    props: [
        {
            attr: 'courseName',
            name: '课程名称',
            sortable: true
        },
        {
            attr: 'status',
            name: '课程状态',
            slot: 'status',
            sortable: true
        },
        {
            attr: 'type',
            name: '课程类型',
            slot: 'type',
            sortable: true
        },
        {
            attr: 'courseClassifyDesc',
            name: '课程形式',
            sortable: true
        },
        {
            attr: 'courseType',
            name: '类别简称',
            sortable: true
        },
        {
            attr: 'courseTime',
            name: '上课时间',
            slot: 'courseTime',
            sortable: true
        },
        {
            attr: 'mainTeacher',
            name: '主讲老师',
            slot: 'mainTeacher',
            sortable: true
        },
        {
            attr: 'lessonQty',
            name: '课时数',
            sortable: true
        }
    ]
}